import ExcelJS from "exceljs";

export async function createXlsxBuffer(rows, sheetName) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);
  const widths = [8, 24, 16, 16, 18, 26, 18, 18, 18, 18, 18, 18, 22, 30];
  worksheet.columns = Object.keys(rows[0]).map((key, index) => ({
    header: key,
    key,
    width: widths[index] || 18,
  }));
  worksheet.addRows(rows);
  const header = worksheet.getRow(1);
  header.font = { bold: true };
  header.height = 24;
  header.eachCell((cell) => {
    cell.alignment = { vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });
  worksheet.getColumn("结存成本").numFmt = "0.00";
  worksheet.getCell("L1").font = { bold: true, color: { argb: "FF000000" } };
  return workbook.xlsx.writeBuffer();
}

export async function exportXlsx(rows, name) {
  if (!rows.length) return;
  const buffer = await createXlsxBuffer(rows, name);
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  try {
    link.href = url;
    link.download = `${name}.xlsx`;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
